import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const SecuredLayout = ({ 
  pageTitle, 
  children
}) => {
  return (
    <Box sx={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
      <Container maxWidth="xl" sx={{ maxWidth: '1400px'}}>
   
          {/* Page Header */}
          <Box sx={{ 
           
            borderBottom: '1px solid #e0e0e0',
            backgroundColor: '#ffffff'
          }}>
            {/* <Typography 
              variant="h4" 
              color="primary" 
              sx={{ 
                fontWeight: 600,
                fontSize: { xs: '1.5rem', md: '2rem' }
              }}
            >
              {pageTitle}
            </Typography> */}
        
          
          {/* Page Content */}
          <Box >
            {children}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SecuredLayout;